import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7474fa5e&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./style/index.scss?vue&type=style&index=0&id=7474fa5e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7474fa5e",
  null
  
)

export default component.exports